import { OktaAuth } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useRouter } from '@tanstack/react-router';
import { ReactNode } from 'react';

export function OktaSecurityContext({
  children,
  oktaAuth,
}: {
  children: ReactNode;
  oktaAuth: OktaAuth;
}) {
  const router = useRouter();
  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={(_, uri) => router.history.push(uri ?? '/')}
    >
      {children}
    </Security>
  );
}
